import script from "./calc.vue?vue&type=script&setup=true&lang=js"
export * from "./calc.vue?vue&type=script&setup=true&lang=js"

import "./calc.vue?vue&type=style&index=0&id=12233976&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12233976"]])

export default __exports__